import promotion from './promotionConfig';
// import apiClient from 'whitelabel_api_requests';
import apiClient from './ens_wht_api_requests/Api/api_client';

export default () => {
    return apiClient(promotion.apiClientConfig);
};
